import React from 'react';
import SeriesTable from './compnents/series-table/series-table';

const Series: React.FC = () => {
  return (
    <div className="w-full h-full">
      <SeriesTable />
    </div>
  );
};

export default Series;
